import throttle from "lodash/throttle";
import { useEffect } from "react";

export const useHitBottom = ({
    fetch,
    enabled = true
}: {
    fetch: () => void;
    enabled?: boolean;
}) => {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        const callback = throttle(() => {
            // Start loading about one screen before the bottom, so the next
            // page usually arrives before the user gets there
            const prefetchDistance = window.innerHeight;
            if (
                window.innerHeight + window.scrollY + prefetchDistance >=
                document.body.offsetHeight
            ) {
                fetch();
            }
        }, 300);

        window.addEventListener("scroll", callback);

        return () => {
            window.removeEventListener("scroll", callback);
            callback.cancel();
        };
    }, [fetch, enabled]);
};
